import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import moment from 'moment-timezone';
import browserStorage from './browserStorage';

const init = (franchisor) => {
	const currentCulture = getCurrentCulture(franchisor);

	// init i18next
	i18n.changeLanguage(currentCulture, (error, t) => {
	});

	// localize moment
	moment.locale(currentCulture);

	setCurrentTimeZone(franchisor, isLocalTimeZone(franchisor), getCurrentTimeZone(franchisor));
};

const getSelectedCulture = (franchisor) => {
	return browserStorage.getFromLocalStorage(franchisor, 'i18n_lng');
};

const getCurrentCulture = (franchisor) => {
	let currentCulture = getSelectedCulture(franchisor);
	if (!currentCulture) {
		// TODO: Obtain default language from country domain
		currentCulture = 'en-GB';
		browserStorage.setToLocalStorage(franchisor, 'i18n_lng', currentCulture);
	}
	return currentCulture;
};

const setCurrentCulture = (franchisor, lang) => {
	browserStorage.setToLocalStorage(franchisor, 'i18n_lng', lang);
	init(franchisor);
};

const getCurrentTimeZone = (franchisor) => {
	return browserStorage.getFromLocalStorage(franchisor, 'timeZone') || moment.tz.guess();
};

const setCurrentTimeZone = (franchisor, useLocalTimeZone, timeZoneName) => {
	if (useLocalTimeZone) {
		browserStorage.removeFromLocalStorage(franchisor, 'timeZone');
		moment.tz.setDefault();
	} else {
		// use selected time zone instead of the local time zone for all dates
		browserStorage.setToLocalStorage(franchisor, 'timeZone', timeZoneName);
		moment.tz.setDefault(timeZoneName);
	}
};

const isLocalTimeZone = (franchisor) => !browserStorage.getFromLocalStorage(franchisor, 'timeZone');

export default {
	init,
	getSelectedCulture,
	getCurrentCulture,
	setCurrentCulture,
	getCurrentTimeZone,
	setCurrentTimeZone,
	isLocalTimeZone
};

i18n
	.use(HttpBackend)
	.use(initReactI18next)
	.init({
		supportedLngs: ['en', 'en-GB', 'bg-BG', 'de-DE', 'en-AU', 'en-US', 'cs-CZ', 'el-GR'], // renamed from `whitelist` in i18next 21
		fallbackLng: 'en',
		//lng: getCurrentCulture(),
		react: {
			// react-i18next v10+ defaults to Suspense while namespaces load. There is no
			// <Suspense> boundary in this app and v8 never suspended, so keep the old
			// behaviour: render with the key/fallback and re-render once loaded.
			useSuspense: false
		},
		ns: ['backofficeresources'],
		defaultNS: 'backofficeresources',
		fallbackNS: 'backofficeresources',	// fallback to 'resources' if default namespace is replaced with a custom namespace for the franchisor
		interpolation: {
			escapeValue: false, // not needed for react!!
			formatSeparator: ',',
			format: function (value, format, lng) {
				if (format === 'uppercase') return value.toUpperCase();
				return value;
			}
		},
		backend: {
			loadPath: (lng, ns) => {
				// __APP_VERSION__ is injected by webpack's DefinePlugin.
				return `/locales/{{lng}}/{{ns}}.json?v=${__APP_VERSION__}`;
			}
		}
		//, debug: true		// use debug info for missing keys to generate replacement tags for <Trans> component
	});

export {
	i18n
};